import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import styles from './checklist.module.css';
import PrismChecklistItem from './checklist/item.gts';

interface PrismChecklistSignature {
  Blocks: {
    default: [
      {
        item: typeof PrismChecklistItem;
      },
    ];
  };
}

const PrismChecklist = <template>
  <ul class={{styles.list}} data-test-id="prism-checklist">
    {{yield (hash item=PrismChecklistItem)}}
  </ul>
</template> satisfies TOC<PrismChecklistSignature>;

export default PrismChecklist;
